<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h5 green darken-3 white--text">Multiple District Reminder</v-card-title>
        <v-card-text class="pt-2 font-weight-regular" dark>
          If you are employed in multiple districts then you will need to complete a separate application for each district.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>            
          <v-btn
            color="blue darken-1"
            text
            @click="emitCloseDialogEvent"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'MultipleDistrictsDialog',
    props: {
        showDialog: Boolean
    },
    methods:{
      emitCloseDialogEvent(){
        this.$emit("close-dialog");
      }
    }
  }
</script>